export default __webpack_public_path__ + "static/media/Switch.4cb8d4c4.svg";